// Global open-state for `<WinnerInfoModal />` — the "how winners work"
// explainer launched from the winner-detail header's info icon. Mounted once
// at the winner-detail level; the header's info button flips `open`. Lifting
// the state into a store keeps the modal mount and its trigger decoupled.

'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

export interface WinnerInfoModalState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useWinnerInfoModalStore: UseBoundStore<StoreApi<WinnerInfoModalState>> =
  createTrackedStore<WinnerInfoModalState>('useWinnerInfoModalStore')((set) => ({
    open: false,
    setOpen: (open: boolean): void => set({ open }),
  }));
